import React, { useMemo } from "react"
import { UseControllerProps, useController, useFormContext } from "react-hook-form"

import SummernoteReact from "app/static/frontend/components/SummernoteWrapper"

import "app/static/stylus/FormStyles.styl"
import "app/static/frontend/forms/stylus/SummernoteField.styl"

type Placeholders = {
    name: string
    items: Array<{
        slug: string
        value: string
        name: string
    }>
}

type SummernoteProps = {
    dataCy?: string
    placeholder?: string
    hideFullscreen?: boolean

    // Summernote Props
    fontNames?: string[]
    fullWidthImage?: boolean
    /* Placeholders the user can insert into the body of the edited content */
    placeholders?: Placeholders[]
    hasTemplates?: boolean
    height?: string
    insertTools?: string[]
    isFocused?: boolean
    isUpdating?: boolean
    needsAutosave?: boolean
    summernoteName?: string
    maxTextLength?: number
    hasPlaceholders?: boolean
} & UseControllerProps

export const Summernote = ({
    dataCy = "",
    placeholder = "",
    hideFullscreen = false,

    // Summernote Props
    fontNames = [],
    fullWidthImage = false,
    hasTemplates = false,
    height = "400px",
    insertTools = ["picture", "link", "table", "hr"],
    isFocused = false,
    isUpdating = false,
    needsAutosave = false,
    placeholders = [],
    summernoteName = "summernote-field",
    maxTextLength,

    // react-hook-form
    name,
    defaultValue,
    rules,
    shouldUnregister,
}: SummernoteProps) => {
    const formContext = useFormContext()
    const { field } = useController({
        name,
        control: formContext.control,
        defaultValue,
        rules,
        shouldUnregister,
    })

    return useMemo(
        () => (
            <SummernoteReact
                dataCy={dataCy}
                editTextObject={(textObject) => {
                    field.onChange(textObject.html_content)
                }}
                fontNames={fontNames}
                fullWidthImage={fullWidthImage}
                hasPlaceholders={Boolean(placeholders.length)}
                hasTemplates={hasTemplates}
                height={height}
                htmlContent={field.value}
                insertTools={insertTools}
                isFocused={isFocused}
                isUpdating={isUpdating}
                maxTextLength={maxTextLength}
                needsAutosave={needsAutosave}
                placeholders={placeholders}
                summernoteName={summernoteName}
                textboxPlaceholder={placeholder}
                hideFullscreen={hideFullscreen}
            />
        ),
        [],
    )
}
